import { render } from "./AppCarouselPage.vue?vue&type=template&id=35016eb1"
import script from "./AppCarouselPage.vue?vue&type=script&lang=js"
export * from "./AppCarouselPage.vue?vue&type=script&lang=js"

import "./AppCarouselPage.vue?vue&type=style&index=0&id=35016eb1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__